<script setup>
import {useModalsStore} from '@/stores/modals'
import TiptapToolbarBtn from "./TiptapToolbarBtn.vue"

const props = defineProps({
    editor: {
        type: Object,
        required: true
    },
    isPidLink: {
        type: Boolean,
        required: true
    }
})

// Pinia Stores
const modalsStore = useModalsStore()

// --- Methods ---

const parseLinkIds = () => {
    const attrs = props.editor.getAttributes('link')
    const href = attrs.href

    let pageId = null
    let contentId = null

    if (href) {
        const match = href.match(/\d+/)
        if (match) {
            const id = parseInt(match[0])

            if (href.includes('PID')) {
                pageId = id
            } else if (href.includes('CID')) {
                contentId = id
            }
        }
    }

    return {pageId, contentId}
}

const openBrowser = () => {
    const {pageId, contentId} = parseLinkIds()

    modalsStore.show({
        componentName: 'SiteTreeModal',
        obj: {
            showContent: true,
            pageId,
            contentId,
            onPageSelect: (selectedPageId) => {
                // Highlight/select the entire existing link first, then apply the new URL
                props.editor
                    .chain()
                    .focus()
                    .extendMarkRange('link')
                    .setLink({href: '[PID:' + selectedPageId + ']'})
                    .run()
            },
            onContentSelect: (pageContentId) => {
                // Highlight/select the entire existing link first, then apply the new URL
                props.editor
                    .chain()
                    .focus()
                    .extendMarkRange('link')
                    .setLink({href: '[CID:' + pageContentId + ']'})
                    .run()
            }
        }
    })
}
</script>

<template>
    <TiptapToolbarBtn
        :iconClass="'bi-file-earmark'"
        :command="openBrowser"
        :is-active="isPidLink"
    />
</template>